module.exports = __webpack_public_path__ + "img/80.ee0757e9.png";